<script>
import posed from "vue-pose";

export default {
    data() {
        return {
            busy: false,
            selectedIndex: -1,
            selectedCategory: null,
            isShowingFilters: false,
            pillars: [],
        };
    },

    props: {
        heading: {
            type: String,
        },
        description: {
            type: String,
        },
        content: {
            type: Array,
             default: function () {
                return [];
            },
        },
    },

    computed: {
        itemsFiltered: function () {
            var self = this,
                itemsMutable = [];

            for (let i = 0; i < self.content.length; i++) {
                var item = self.content[i];

                if (self.selectedCategory) {
                    if (
                        !self.itemHasCategory(
                            item,
                            self.selectedCategory.slug
                        )
                    ) {
                        continue;
                    }
                }

                itemsMutable.push(item);
            }

            return itemsMutable;
        },
    },

    watch: {
        selectedCategory: function (newValue, oldValue) {
            var self = this;

            setTimeout(function () {
                window.dispatchEvent(new Event("resize"));
            }, 500);
        },
    },

    methods: {
        didSelectIndex: function (index) {
            this.selectedIndex = this.selectedIndex === index ? -1 : index;
        },
        didSelectCategory: function (category) {
            this.selectedCategory = category;
        },
        reloadCategories: function () {
            var termsMutable = [];

            for (let i = 0; i < this.content.length; i++) {
                var item = this.content[i];
                if (item.pillars.length) {
                    for (
                        let ii = 0;
                        ii < item.pillars.length;
                        ii++
                    ) {
                        var category = item.pillars[ii];
                        var existingCategory = termsMutable.find((item) => {
                            return item.slug == category.slug;
                        });

                        if (!existingCategory) {
                            termsMutable.push(category);
                        }
                    }
                }
            }

            this.categories = termsMutable;
        },
        didSelectFilter: function (termObject) {
            this.selectedItemTypeSlug = termObject ? termObject.slug : null;
        },
        itemHasCategory: function (item, slug) {
            if (!item.pillars || !item.pillars.length) {
                return false;
            }

            for (let i = 0; i < item.pillars.length; i++) {
                if (item.pillars[i].slug === slug) {
                    return true;
                }
            }

            return false;
        },
        didSelectToggleFilters: function () {
            this.isShowingFilters = !this.isShowingFilters;
        },
    },

    components: {
        Body: posed.div({
            open: {
                opacity: 1,
                height: "auto",
            },
            closed: {
                opacity: 1,
                height: 0,
                transition: { duration: 300 },
            },
        }),
    },

    created() {},
    mounted() {
        this.reloadCategories();
    },

};
</script>

<style></style>

<template>

    <div class="accordion-content">

        <div class="accordion-content__filters">
                    <span>Filter:</span>

            <button
                v-on:click.prevent="didSelectCategory(null)"
                class="button"
                :class="{ selected: !selectedCategory }"
            >
                All
            </button>
            <div v-for="category in categories" :key="category.slug">
                <button
                    v-on:click.prevent="didSelectCategory(category)"
                    class="button"
                    :class="{
                        selected:
                            selectedCategory &&
                            selectedCategory.slug === category.slug,
                    }"
                >
                    {{ category.title }}
                </button>
            </div>
        </div>

        
        <div class="accordion-content__header">
            <h5 v-if="heading" class="accordion-content__heading category-title">
                {{ heading }}
            </h5>

            <p
                v-if="description && description.length"
                class="accordion-content__description"
                v-html="description"
            ></p>
        </div>

        <transition-group name="fade" mode="out-in">
            <article
                v-for="(item, index) in itemsFiltered"
                :key="index + '-' + index"
                class="accordion-content__item"
                :class="{ 'accordion-content__item--open': selectedIndex == index }"
            >
                <div class="accordion-content__item__header">
                    <h2 class="accordion-content__item__header__title">{{ item.title }}</h2>
                    <div class="accordion-content__item__header__category">
                        <span v-for="term in item.pillars" :key="term.slug">{{ term.title }}</span>
                    </div>
                    <button v-on:click.prevent="didSelectIndex(index)">
                        <span class="sr-only">Read More</span>
                    </button>
                </div>

                <Body
                    class="accordion-content__item__body"
                    :pose="selectedIndex == index ? 'open' : 'closed'"
                >
                    <div class="accordion-content__item__body__inner">
                        <div class="accordion-content__item__body__content">
                            <div v-html="item.content"></div>
                            <div v-html="item.services_snippet"></div>
                            <div
                                v-if="item.button_url"
                                class="accordion-content__item__body__content__footer"
                            >
                                <a class="button" :href="item.button_url">{{
                                    item.button_label
                                }}</a>
                            </div>
                        </div>
                    </div>
                </Body>
            </article>
        </transition-group>
    </div>
</template>
